import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from '../../utils/translate';
import Link from './components/Link';
import SocialButtons from '../../components/SocialButtons';
import Info from './components/Info';
import LanguageSelector from '../LanguageSelector';
import { cookieManager } from 'libs/cookie';

import './index.scss';

import * as sprite from './static/img/sprite.svg';

interface Props {
  isBig?: boolean;
  theme?: 'dark';
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('footer');

const enhance = compose<Enhanced, Props>(translate);

const Footer: React.FC<Enhanced> = ({ t, isBig, theme }) => {
  const goToMobileVersion = () => {
    if (typeof window === 'undefined') {
      return;
    }
    cookieManager.set('preferred_platform', 'mobile');
    window.location.reload();
  };

  return (
    <footer className={b({ big: isBig, theme })} data-testid="footer">
      <div className={b('wrapper')}>
        <div className={b('row')}>
          <div className={b('contacts')}>
            <a
              href="https://t.me/ut_personal_manager_bot"
              className={b('contacts-link')}
              target="_blank"
            >
              {t('Contact via Telegram')}
            </a>
            <a href="https://wa.me/79959221420" className={b('contacts-link')} target="_blank">
              {t('Contact via WhatsApp')}
            </a>
            <Link to="mailto:welcome@unitedtraders.com">welcome@unitedtraders.com</Link>
          </div>
          <div className={b('navigation')}>
            <Link to="/investments">{t('Investments')}</Link>
            <Link to="https://partners.utex.io">{t('Partnership')}</Link>
            <Link to="/trading/analytics">{t('Trading')}</Link>
            <Link to="/contacts">{t('Contacts')}</Link>
          </div>
          <div className={b('socials')}>
            <SocialButtons size="small" />
          </div>
          <div className={b('info')}>
            <Info />
          </div>
        </div>
        <div className={b('row')}>
          <button className={b('mobile-version-btn')} onClick={goToMobileVersion}>
            <svg className={b('mobile-version-btn-icon')}>
              <use xlinkHref={`${sprite}#icon_mobile-version`} />
            </svg>
            {t('Mobile version')}
          </button>
          <LanguageSelector />
        </div>
      </div>
    </footer>
  );
};

export default enhance(Footer);
